import { OnInit } from '@angular/core';
import { UXBlocksGroup } from '../../../core/models/ux-page';
var BlocksGroupComponent = /** @class */ (function () {
    function BlocksGroupComponent() {
    }
    BlocksGroupComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(BlocksGroupComponent.prototype, "code", {
        get: function () {
            if (this.blocksGroup) {
                return this.blocksGroup.code;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlocksGroupComponent.prototype, "hasBlocks", {
        get: function () {
            if (this.blocksGroup && this.blocksGroup.blocks && this.blocksGroup.blocks.length) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    return BlocksGroupComponent;
}());
export { BlocksGroupComponent };
